import type { ReactNode } from "react"

import { PopoverContext } from "./PopoverContext"
import type { PopoverOptions } from "./PopoverOptions"
import { usePopover } from "./usePopover"

export interface Props extends PopoverOptions {
  children: ReactNode;
}

/*
 * a popover is a component that appears on top of the page when a trigger is clicked
 * it is like a modal or a dialog except it does not hide the content below it
 */
export function Popover({
  children,
  ...options
}: Props) {
  const popover = usePopover(options)
  return (
    <PopoverContext.Provider value={popover}>
      {children}
    </PopoverContext.Provider>
  )
}
